import { useSettingsStore } from '../store'
import { HourConfigField } from './HourConfigField'

export function RiskFraudHoursTab() {
  const { hourSettings, updateRiskHours, updateFraudTxmHours } = useSettingsStore()
  const risk = hourSettings.risk
  const fraudTxm = hourSettings.fraudTxm

  return (
    <div className="space-y-6">
      {/* Risk Configuration */}
      <div className="bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-lg p-4">
        <h4 className="text-sm font-medium text-[var(--text-primary)] mb-3">Risk Configuration</h4>
        <HourConfigField
          label="Risk Rating Base Setup"
          value={risk.baseSetup}
          onChange={(v) => updateRiskHours('baseSetup', v)}
          description="Initial risk rating system configuration"
        />
        <HourConfigField
          label="Per Custom Risk Factor"
          value={risk.perCustomRiskFactor}
          onChange={(v) => updateRiskHours('perCustomRiskFactor', v)}
          description="Hours per custom risk factor (lookup, truth, range, direct)"
        />
        <HourConfigField
          label="Scoring Matrix Setup"
          value={risk.scoringMatrixSetup}
          onChange={(v) => updateRiskHours('scoringMatrixSetup', v)}
          description="Risk scoring matrix configuration"
        />
        <HourConfigField
          label="Individual Risk Model"
          value={risk.individualModelSetup}
          onChange={(v) => updateRiskHours('individualModelSetup', v)}
          description="Individual risk model configuration"
        />
      </div>

      {/* Fraud & Transaction Monitoring */}
      <div className="bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-lg p-4">
        <h4 className="text-sm font-medium text-[var(--text-primary)] mb-3">Fraud & Transaction Monitoring</h4>
        <HourConfigField
          label="Fraud Setup"
          value={fraudTxm.fraudSetup}
          onChange={(v) => updateFraudTxmHours('fraudSetup', v)}
          description="Fraud detection configuration"
        />
        <HourConfigField
          label="Transaction Monitoring Setup"
          value={fraudTxm.transactionMonitoringSetup}
          onChange={(v) => updateFraudTxmHours('transactionMonitoringSetup', v)}
          description="Transaction monitoring configuration"
        />
      </div>
    </div>
  )
}
